import Vue from 'vue'
import Router from 'vue-router'
import Index from '../views/index'
import inewsCon from '../views/inews_con'
// import tiantan from '../views/tiantan'
// import indexC from '../components/tiantan/index_c'
// import tiantanEn from '../views/tiantan_en'
import sIndex from '../views/s_index'
import oIndex from '../views/o_index'
import Hotel from '../components/sign/hotel'
import Invoice from '../components/sign/invoice'
import Order from '../components/sign/order'
import morder from '../components/sign/morder'
import Pay from '../components/sign/pay'
import addInfo from '../components/sign/addInfo'
import apply from '../components/sign/apply'
// 会议首页模板1
import tpl1 from  '../views/tpl1'
// 带有讲着，第一套模板pc
import tpl1Home from '../components/tpl1/index'
// 会议日常组件
import daily from '../components/tpl2/daily'

import tempView from '../views/temp_view'
import tempView1 from '../views/temp_view1'
import tempView2 from '../views/temp_view_cn'
//征文投稿组件
import paperView from "../components/paper/overview"
import paperIndexView from "../views/paper_index"
// import paperSubmitView from "../components/paper/submit"
import Abstract from "../components/paper/Abstract"
import Preview from "../components/paper/Preview"
import Success from "../components/paper/Success"
import Author from "../components/paper/AuthorsInfo"
import paperStatusView from "../components/paper/Status"

//中文征文投稿组件

//模板 互动平台页面
import hudong from '../components/tpl2/hudong'
import hdList from '../components/tpl2/hdList'
import tpl3home from '../components/tpl3/tpl3.vue'
import tpl4home from '../components/tpl4/tpl4.vue'

//日程讲者列表
const personlist = resolve => require(['@/components/calendar/personlist/personlist'], resolve);
const personDetail = resolve => require(['@/components/calendar/personlist/personDetail'], resolve);
const callist = resolve => require(['@/components/calendar/callist/callist'], resolve);
const searchList = resolve => require(['@/components/calendar/callist/searchList'], resolve);
const calDetail = resolve => require(['@/components/calendar/callist/calDetail'], resolve);
//网络科室会
const deptmeet = resolve => require(['@/components/deptmeet/index.vue'], resolve);

//直播详情
const livedetail = resolve => require(['@/components/live/index.vue'], resolve);
//直播列表
const live = resolve => require(['@/components/livelist/index.vue'], resolve);
//评分
const screenScore = resolve => require(['@/components/screenScore/screenScore.vue'], resolve);
import view from 'base/view.vue'
Vue.use(Router);


export default new Router({
  mode: 'history',
  fallback: false,
  routes: [
    {
      path: '/webpc/view/:cid/:infoId',
      component: view
    },
    {
      path: '/webpc/tpl3home/:cid',
      name: 'tpl3home',
      component: tpl3home
    },
    {
      path: '/webpc/tpl4home/:cid',
      name: 'tpl4home',
      component: tpl4home
    },
    {
      path: '/webpc/hd/:cid',//互动页面，cid 会议id liveid 直播id
      component: hudong
    },
    {
      path: '/webpc/hd/:cid/:liveId',//互动页面，cid 会议id liveId 直播id
      component: hdList
    },
    {
      path: '/webpc/tpl1home/:cid',
      name: 'tpl1home',
      component: tpl1Home
    },
    {
      path: '/webpc/tpl/:id',
      name: 'tpl1',
      component: tpl1,
      children: [
        {
          path: '/webpc/tpl/:id/daily',
          component: daily
        },

      ]
    },
    {
      path: '/webpc/home_detail/:id',// 会议的id
      name: '',
      component: tempView,//模板2
    },
    {
      path: '/webpc/home_detail1/:id',// 会议的id
      name: '',
      component: tempView1,//模板2
    },
    {
      path: '/webpc/index',
      name: 'index',
      // component: Index,//模板1
      component: Index,//模板2
    },
    {
      path: '/webpc/news/:id',
      component: inewsCon,
      name: 'newsCon'
    },
    {
      path: '/webpc/sign',
      component: sIndex,
      children: [
        {path: '/webpc/sign/hotel/:opFlag', component: Hotel},//预定酒店
        {path: '/webpc/sign/invoice/:opFlag', component: Invoice},//发票信息
        {path: '/webpc/sign/pay', component: Pay}, // 支付
        {path: '/webpc/sign/add/:opFlag', component: addInfo}, // 完善信息
        {path: '/webpc/sign/apply/:opFlag', component: apply},//报名类型
        {path: '/webpc/sign/morder', component: morder}//报名类型
      ]
    },
    {
      path: '/webpc/order',
      component: oIndex,
      children: [
        {path: '/order/info', component: Order},//确认报名
      ]
    },

    //网络科室会
    {
      path:'/webpc/deptmeet/:dmid',
      name:'deptmeet',
      component:deptmeet
    },

    //直播详情
    {
      path:'/webpc/live/:lcid',
      name:'live',
      component:live
    },
    {
      path:'/webpc/livedetails/:liveid',
      name:'livedetail',
      component:livedetail
    },

    //日程页面
    {
      path: '/webpc/personlist/:cid',
      name: 'personlist',
      component: personlist,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/webpc/personDetail/:pid',
      name: 'personDetail',
      component: personDetail,

    },
    {
      path: '/webpc/callist/:cid',
      name: 'callist',
      component: callist,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/webpc/searchList/:cid',
      name: 'searchList',
      component: searchList,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/webpc/calDetail/:calid',
      name: 'calDetail',
      component: calDetail
    },
    {
      path: '/webpc/screenScore/:markid',
      name: 'screenScore',
      component: screenScore
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js